import { Link } from 'rebass';
import GatsbyLink from 'gatsby-link';
import styled from 'styled-components';
import { defaultProps, withProps, compose } from 'recompose';
import theme from '../../themes';

export default compose(
  defaultProps({
    color: 'brandLight',
  }),
  withProps(({ to }) => ({
    is: to ? GatsbyLink : null,
  })),
)(styled(Link)`
  cursor: pointer;
  transition: color cubic-bezier(.4, 0, .2, 1) 100ms;

  &:hover {
    color: ${theme.colors.brandDark};
  }
`);



// WEBPACK FOOTER //
// ./src/app/components/link/index.js